export default __webpack_public_path__ + "static/media/clock.ac3786ca.svg";